var pic1 = require('../../assets/images/facility/library/pic1.jpg');
var pic2 = require('../../assets/images/facility/library/pic2.jpg');
var pic3 = require('../../assets/images/facility/library/pic3.jpg');
var pic4 = require('../../assets/images/facility/library/pic4.jpg');
var pic5 = require('../../assets/images/facility/library/pic2.jpg');
const DataGalleryFacilitylibrary = [
 {    
	id: 1,
	title:"Library",
    image: pic1,	    
	alt  :"Library",
  },
  {    
	id: 2,
	title:"Library",
    image: pic2,	    
	alt: "Library",
  },
  {    
	id: 3,
	title:"Library",
    image: pic3,	    
	alt: "Library",
  },
  {    
	id: 4,
	title:"Library",
    image: pic4,	    
	alt: "Library",
  },
  {    
	id: 5,
	title:"Library",
    image: pic5,	    
	alt: "Library",
  },
];
export default DataGalleryFacilitylibrary;